export const DEFAULT_AVATAR =
  "https://static-cdn.jtvnw.net/user-default-pictures-uv/13e5fa74-defa-11e9-809c-784f43822e80-profile_image-300x300.png";
export const PRIZES_OUTSIDE_ADDITIONAL_PRIZES_COUNT = 3;

type PlatformUrls = {
  [key: string]: string;
};

export const HYUS_USERNAME = "hyuslive";
export const WATCH_GAMES_USERNAME = "watchgamestv";
export const PKLE_USERNAME = "pkle";
export const SAMJUNIOR_USERNAME = "samjuniortv";
export const WREWARDS_USERNAME = "wrewards";

export const Streamers_Usernames = [
  HYUS_USERNAME,
  WATCH_GAMES_USERNAME,
  PKLE_USERNAME,
  SAMJUNIOR_USERNAME,
  WREWARDS_USERNAME,
];

export enum STREAMING_PLATFORMS {
  TWITCH = "twitch",
  KICK = "kick",
}

export enum HouseGameType {
  MINES = "MINES",
  COINFLIP = "COINFLIP",
  BLACKJACK = "BLACKJACK",
  ROULETTE = "ROULETTE",
  WHEEL = "WHEEL",
  PLINKO = "PLINKO",
  CRASH = "CRASH",
  KENO = "KENO",
}

export const WatchGamesTVLinks: PlatformUrls = {
  discord: "https://discord.com/invite/watchgamestv",
  youtube: "https://www.youtube.com/@WatchGamesTV",
  twitter: "https://twitter.com/WatchGamesTV",
  kick: "https://kick.com/watchgamestv",
  twitch: "https://www.twitch.tv/watchgamestv",
  instagram: "https://www.instagram.com/ibbyyzekerie",
};

export const SamJuniorTVLinks: PlatformUrls = {
  discord: "https://discord.com/invite/HTPJVHEqyp",
  youtube: "https://www.youtube.com/@samjuniortv",
  twitter: "https://x.com/samjuniortv",
  kick: "https://kick.com/samjuniortv",
  twitch: "https://www.twitch.tv/samjuniortv",
  instagram: "https://www.instagram.com/samjuniortv",
};

export const HyusLinks: PlatformUrls = {
  discord: "https://discord.gg/9mCYGPuapv",
  youtube: "https://www.youtube.com/c/hyuslive",
  twitter: "https://twitter.com/hyuslive",
  kick: "https://kick.com/hyuslive",
  twitch: "https://www.twitch.tv/hyuslive",
  instagram: "https://www.instagram.com/hyuslive",
};

export const WRewardsLinks: PlatformUrls = {
  discord: WatchGamesTVLinks.discord,
  youtube: WatchGamesTVLinks.youtube,
  twitter: "https://twitter.com/WRewardscom",
  kick: "https://kick.com/wrewards",
  twitch: WatchGamesTVLinks.twitch,
  instagram: "https://www.instagram.com/wrewards",
};

export const PkleLinks: PlatformUrls = {
  discord: WatchGamesTVLinks.discord,
  youtube: "https://www.youtube.com/@PKLE",
  twitter: "https://twitter.com/lilpkle",
  kick: "https://kick.com/pkle",
  twitch: "https://www.twitch.tv/pkle",
  instagram: WRewardsLinks.instagram,
};

export const Streamers_Kick_Links = [
  WatchGamesTVLinks.kick,
  SamJuniorTVLinks.kick,
  WRewardsLinks.kick,
  PkleLinks.kick,
  HyusLinks.kick,
];

export enum SocketEvent {
  // raffles
  AuthError = "AuthError",
  RaffleRouletteStarts = "RaffleRouletteStarts",
  RaffleStartOneRoulette = "RaffleStartOneRoulette",
  RaffleEnded = "RaffleEnded",
  NewRaffle = "NewRaffle",
  NewRaffleEntry = "NewRaffleEntry",
  RaffleEndsSoon = "RaffleEndsSoon",
  // streams
  StreamsStatusesCheck = "StreamsStatusesCheck",
  StreamStatusNotify = "StreamStatusNotify",
  NotifyNewCalendarDay = "NotifyNewCalendarDay",
  // stream guests
  StreamGuestsDashboardUpdate = "StreamGuestsDashboardUpdate",
  // dashboard
  DashboardStatsUpdate = "DashboardStatsUpdate",
  // points shop
  PointsShopItemCreated = "PointsShopItemCreated",
  PointsShopItemUpdated = "PointsShopItemUpdated",
  PointsShopItemDeleted = "PointsShopItemDeleted",
  PointsShopItemsRestocked = "PointsShopItemsRestocked",
  PointsShopItemPurchased = "PointsShopItemPurchased",
  PointsShopDashboardStatsUpdate = "PointsShopDashboardStatsUpdate",
  // bet
  LiveBets = "LiveBets",
  // rates
  RatesUpdate = "RatesUpdate",
  // personal
  BalanceUpdate = "BalanceUpdate",
  // utils
  NotifyNewNotification = "NotifyNewNotification",
  //Leaderboard
  LeaderboardRaffleRouletteStarts = "LeaderboardRaffleRouletteStarts",
  LeaderboardRaffleWinnerPing = "LeaderboardRaffleWinnerPing",
  //challenges
  ChallengeStart = "ChallengeStart",
  ChallengeEndSoon = "ChallengeEndSoon",
  ChallengeWin = "ChallengeWin",
}

export enum SocketMessage {
  //bet
  LiveBetsMessage = "LiveBetsMessage",
  ClientBalanceUpdate = "ClientBalanceUpdate",
}

export enum WheelSocketEvent {
  WheelInfo = "WheelInfo",
  WheelState = "WheelState",
  WheelHistory = "WheelHistory",
  WheelEnded = "WheelEnded",
  WheelPlayerBet = "WheelPlayerBet",
  WheelError = "WheelError",
}

export enum CrashSocketEvent {
  CrashState = "CrashState",
  AuthError = "AuthError",
  CrashError = "CrashError",
  CrashPlayerBet = "CrashPlayerBet",
  CrashPlayerCashout = "CrashPlayerCashout",
  CrashActiveGameBettorsResponse = "CrashActiveGameBettorsResponse",
}

export enum CrashSocketMessage {
  CrashJoin = "CrashJoin",
  CrashLeave = "CrashLeave",
  CrashRegisterBet = "CrashRegisterBet",
  CrashPlaceBet = "CrashPlaceBet",
  CrashPlaceBets = "CrashPlaceBets",
  CrashCashout = "CrashCashout",
  CrashCancelBetRegistration = "CrashCancelBetRegistration",
  CrashActiveGameBettorsRequest = "CrashActiveGameBettorsRequest",
  CrashGetLastGames = "CrashGetLastGames",
}

export enum WheelSocketMessage {
  WheelJoin = "WheelJoin",
  WheelGetInfo = "WheelGetInfo",
  WheelLeave = "WheelLeave",
  WheelPlaceBet = "WheelPlaceBet",
}

export enum CoinBoxSocketMessage {
  CoinBoxJoinRoom = "CoinBoxJoinRoom",
  CoinBoxLeaveRoom = "CoinBoxLeaveRoom",
}

export enum CoinBoxSocketEvent {
  CoinBoxOpened = "CoinBoxOpened",
}

export enum ADVENT_DAY_STATUS {
  Past = "past",
  Current = "current",
  Future = "future",
}

export enum TRANSACTION_STATUS {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export const CALENDAR_API_CODES = {
  ADV_CALENDAR_NOT_TODAY: "ADV_CALENDAR_NOT_TODAY",
  ADV_CALENDAR_DAY_ACTIVATED: "ADV_CALENDAR_DAY_ACTIVATED",

  ADV_CALENDAR_DAY_NOT_FOUND: "ADV_CALENDAR_DAY_NOT_FOUND",

  ADV_CALENDAR_RAFFLE_DOES_NOT_EXIST: "ADV_CALENDAR_RAFFLE_DOES_NOT_EXIST",

  ADV_CALENDAR_DISCORD_VERIFICATION_REQUIRED: "ADV_CALENDAR_DISCORD_VERIFICATION_REQUIRED",

  ADV_CALENDAR_GAMDOM_REQUIRED: "ADV_CALENDAR_GAMDOM_REQUIRED",

  ADV_CALENDAR_UNKNOWN_RULE_TYPE: "ADV_CALENDAR_UNKNOWN_RULE_TYPE",
};

export enum ADVENT_DAY_PRIZE_TYPE {
  RAFFLE = "raffle",
  POINTS = "points",
  PROMOCODE = "promocode",
}

export enum ADVENT_CALENDAR_THEME {
  EASTER = "easter",
  MAY = "may",
  JUNE = "june",
  SEPTEMBER = "september",
  OCTOBER = "october",
  NOVEMBER = "november",
  DECEMBER = "december",
  APRIL = "april",
  BEACH = "beach",
  SEASIDE = "seaside",
  TROPICAL = "tropical",
  OCEAN = "ocean",
  JANUARY = "january",
  FEBRUARY = "february",
  GAMDOM = "gamdom",
}

export const ConnectionSelectionOptions = [
  {
    value: "All",
    title: "All",
  },
  {
    value: "DISCORD_ID",
    title: "Discord ID",
  },
  {
    value: "DISCORD_USERNAME",
    title: "Discord Username",
  },
  {
    value: "TWITCH_ID",
    title: "Twitch ID",
  },
  {
    value: "TWITCH_USERNAME",
    title: "Twitch Username",
  },
  {
    value: "GOOGLE_ID",
    title: "Google ID",
  },
  {
    value: "GOOGLE_USERNAME",
    title: "Google Username",
  },
  {
    value: "STEAM_ID",
    title: "Steam ID",
  },
  {
    value: "STEAM_USERNAME",
    title: "Steam Username",
  },
  {
    value: "STEAM_PARTNER_ID",
    title: "Steam Partner ID",
  },
  {
    value: "KICK_ID",
    title: "Kick ID",
  },
  {
    value: "KICK_USERNAME",
    title: "Kick Username",
  },
  {
    value: "GAMDOM_ID",
    title: "Gamdom ID",
  },
  {
    value: "EMAIL",
    title: "Email",
  },
  {
    value: "BTC_ADRESS",
    title: "BTC",
  },
  {
    value: "ETH_ADRESS",
    title: "ETH",
  },
  {
    value: "LTC_ADRESS",
    title: "LTC",
  },
  {
    value: "USDT_ERC20_ADRESS",
    title: "USDT",
  },
  {
    value: "USERNAME",
    title: "Username",
  },
];

export enum BlackjackPlayerActions {
  HIT = "HIT",
  STAND = "STAND",
  DOUBLE_DOWN = "DOUBLE_DOWN",
  SPLIT = "SPLIT",
  BUY_INSURANCE = "BUY_INSURANCE",
  REJECT_INSURANCE = "REJECT_INSURANCE",
  // to trigger init animation
  INIT_GAME = "INIT_GAME",
}

export enum BlackjackInsuranceStatus {
  INELIGIBLE = "INELIGIBLE",
  ELIGIBLE = "ELIGIBLE",
  BOUGHT_PAYS_OUT = "BOUGHT_PAYS_OUT",
  BOUGHT_DOES_NOT_PAY_OUT = "BOUGHT_DOES_NOT_PAY_OUT",
  REJECTED = "REJECTED",
}

export enum BlackjackOutcomes {
  LOSS = "LOSS",
  WIN = "WIN",
  PENDING = "PENDING",
  NONE = "NONE",
  BLACKJACK = "BLACKJACK",
  DRAW = "DRAW",
  INSURED = "INSURED",
}

export enum GameStatus {
  IN_PROGRESS = "IN_PROGRESS",
  FINISHED = "FINISHED",
  NOT_STARTED = "NOT_STARTED",
}

export const finishedStatuses = [
  BlackjackOutcomes.LOSS,
  BlackjackOutcomes.WIN,
  BlackjackOutcomes.DRAW,
  BlackjackOutcomes.BLACKJACK,
  BlackjackOutcomes.INSURED,
];
